import { Directive, Input, TemplateRef } from '@angular/core';

/** Marks an `ng-template` as a cell renderer for `app-list-module-table` column `id`. */
@Directive({
  selector: '[listCellDef]',
  standalone: true,
})
export class ListCellDefDirective {
  @Input('listCellDef') columnId!: string;

  constructor(public readonly template: TemplateRef<unknown>) {}
}
